module.exports = __webpack_public_path__ + "aac2ff98a7df1c0eb0a743691e6dad00.png";